import React from 'react';
import {styled} from '@mui/material/styles';
import {useSelector} from "react-redux";
import {Box, CircularProgress} from "@mui/material";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import CenterTableCell from "./CenterTableCell";
import Typography from "@mui/material/Typography";


const StyledTableWrapper = styled(Box)(({theme}) => ({
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
        width: '100vw',
    }
}));

const StyledTitle = styled(Typography)(({theme}) => ({
    padding: theme.spacing(1, 2),
    textAlign: 'center',
}));

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default function StatsSection() {

    const statsLoading = useSelector(state => state.image.statsLoading);
    const statsSet = useSelector(state => state.image.statsSet);
    const width = useSelector(state => state.image.width);
    const height = useSelector(state => state.image.height);
    const percentage = useSelector(state => state.image.percentage);
    const black = useSelector(state => state.image.black);
    const blackLoading = useSelector(state => state.image.blackLoading);

    return (
        <>
            <StyledTitle variant={'h5'}>
                Stats {statsLoading && <CircularProgress size={24} color="inherit"/>}
            </StyledTitle>
            <Grid item xs={12} sx={{mb: 2}}>
                <StyledTableWrapper>
                    <Table size={'small'}>
                        <TableBody>
                            <TableRow>
                                <CenterTableCell><Typography variant="h6">Dimensions:</Typography></CenterTableCell>
                                <CenterTableCell>
                                    {statsLoading && <CircularProgress size={16} color={'inherit'}/>}
                                    {statsSet && !statsLoading && <Typography variant="body1" align="right">{width*height > 0 ? `${width}x${height}` : ''}</Typography>}
                                </CenterTableCell>
                            </TableRow>
                            <TableRow>
                                <CenterTableCell><Typography variant="h6">Total pixels:</Typography></CenterTableCell>
                                <CenterTableCell>
                                    {statsLoading && <CircularProgress size={16} color={'inherit'}/>}
                                    {statsSet && !statsLoading && <Typography variant="body1" align="right">{width*height > 0 ? numberWithCommas(width*height) : ''}</Typography>}
                                </CenterTableCell>
                            </TableRow>
                            <TableRow>
                                <CenterTableCell><Typography variant="h6">Black pixels:</Typography></CenterTableCell>
                                <CenterTableCell>
                                    {(statsLoading || blackLoading) && <CircularProgress size={16} color={'inherit'}/>}
                                    {statsSet && !statsLoading && <Typography variant="body1" align="right">{numberWithCommas(black)}</Typography>}
                                </CenterTableCell>
                            </TableRow>
                            <TableRow>
                                <CenterTableCell><Typography variant="h6">Percentage:</Typography></CenterTableCell>
                                <CenterTableCell align="right">
                                    {(statsLoading || blackLoading) && <CircularProgress size={16} color={'inherit'}/>}
                                    {statsSet && !statsLoading && <Typography variant="body1" align="right" display="inline">{`${percentage.toFixed(2)} %`}</Typography>}
                                </CenterTableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </StyledTableWrapper>
            </Grid>
        </>
    );
}


